module.exports = __webpack_public_path__ + "assets/images/3ae13bc863b5aebd90257119aa4b22f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/facebook.svg
// module id = 724
// module chunks = 0